import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DashboardIcon, ReportIcon } from "../icon/icon";
import { notAllowFooter, routes } from "../helpers/constants";
import { checkIsEnable } from "../helpers/commonFunction";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleChangePage = (tab) => {
    navigate(tab.to);
  };

  const getFooterLinks = () => {
    return [
      {
        to: routes.takeDetails,
        icon: DashboardIcon,
        label: "Dashboard",
        isActive: checkIsEnable(routes.takeDetails),
        disabled: false,
        activePages: [routes.takeDetails],
      },
      {
        to: routes.reports,
        icon: ReportIcon,
        label: "Itinerary",
        isActive: checkIsEnable(routes.reports),
        disabled: false,
        activePages: [routes.reports],
      },
    ];
  };

  return (
    <>
      {!notAllowFooter.includes(location?.pathname) && (
        <footer className="tc-footer">
          <div
            className={`tc-footer-content ${
              getFooterLinks()?.length < 2
                ? "justify-content-center"
                : getFooterLinks()?.length < 4
                ? "justify-content-around"
                : ""
            }`}
          >
            {getFooterLinks().map((tab, i) => {
              if (tab.isActive) {
                return (
                  <span
                    key={i}
                    role="button"
                    onClick={() => handleChangePage(tab)}
                    className={`tc-footer-tab ${
                      location.pathname === tab.to
                        ? "active"
                        : tab.to === routes.takeDetails &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : tab.to === routes.reports &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : tab.to === routes.dmPortal &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : tab.to === routes.adminPortal &&
                          tab.activePages.includes(location.pathname)
                        ? "active"
                        : ""
                    } ${tab.disabled && "pe-none"}`}
                  >
                    {tab.icon}
                    {tab.label}
                  </span>
                );
              } else {
                return null;
              }
            })}
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
